<template>
  <SettingSection
    title="Транспорт"
    icon-variant="transport"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";
import { can } from "@/utils/permissionUtils";

export default {
  name: "TransportSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M10 17h4V5H2v12h3"></path>
        <path d="M14 17h1"></path>
        <path d="M15 8h4l3 4v5h-3"></path>
        <circle cx="7.5" cy="17.5" r="2.5"></circle>
        <circle cx="17.5" cy="17.5" r="2.5"></circle>
      `,
      allLinks: [
        {
          label: "Транспорт",
          route: { name: "Vehicles" },
        },
        {
          label: "Документы ТС",
          route: { name: "VehicleDocuments" },
        },
        {
          label: "Приёмка и передача ТС",
          route: { name: "VehicleInspectionSettings" },
        },
      ],
    };
  },

  computed: {
    links() {
      return this.allLinks.filter((link) => (
        link.route.name !== "VehicleInspectionSettings" || can("Fleet::Vehicle::InspectionStep", "update")
      ));
    },
  },
};
</script>
